import * as React from "react";
import { FaShareAlt, FaSyncAlt } from "react-icons/fa";
import { Tooltip } from ".";
import styled, { css } from "styled-components/macro";
import { useRecommendation } from "../../../contexts/recommendation-context";
import * as mq from "../../../styles/mediaQueries";
import * as colors from "../../../styles/colors";
import * as fonts from "../../../styles/fonts";
import { Link, useParams } from "react-router-dom";
import { FewMoreQuestionsModal } from "./FewMoreQuestionsModal";
import { useMutation } from "react-query";
import { incomeMultiplier } from "../../../utils/enquiry";
import { useForm } from "react-hook-form";
import { yup } from "../../../utils/yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { amountToNumber, NumberField } from "../../../component/formFields";

const manualSumAssuredSchema = yup.object({
  manualSumAssured: yup.string().required("This field is required").minValue({
    min: 2500000,
    errorMessage: "Please enter morer than 25 Lakhs",
  }),
});

function ResultLeft({ data }) {
  const { broker } = useRecommendation();
  const [fewMoreQuestionsModalShow, setFewMoreQuestionsModalShow] =
    React.useState(false);

  const {
    answers: { name, age, income },
  } = useRecommendation();

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({ resolver: yupResolver(manualSumAssuredSchema) });

  const [manualSumAssured, setManualSumAssured] = React.useState("");

  const { enquiryId } = useParams();

  const { mutateAsync: getIncomeMultiplier } = useMutation(manualSumAssured =>
    incomeMultiplier({
      age: age,
      sum_assured: manualSumAssured,
      annual_income: income,
      enquiryId,
    }),
  );

  const handleQuotesClick = data => {
    const manualSumAssuredInNumber = amountToNumber(data.manualSumAssured);
    if (broker === "alliance") {
      getIncomeMultiplier(manualSumAssuredInNumber).then(res => {
        if (res.message !== "Success") {
          alert(res.message);
          setManualSumAssured(manualSumAssuredInNumber);
          setFewMoreQuestionsModalShow(true);
        } else {
          setManualSumAssured(manualSumAssuredInNumber);
          setFewMoreQuestionsModalShow(true);
        }
      });
    } else {
      setManualSumAssured(manualSumAssuredInNumber);
      setFewMoreQuestionsModalShow(true);
    }
  };

  return (
    <div
      css={`
        width: 60%;
        padding-top: 2em;
        display: flex;
        flex-flow: column;
        justify-content: space-around;

        ${mq.sm} {
          width: 100%;
        }
      `}
    >
      <div
        css={`
          ${mq.sm} {
            margin-top: -1em;
          }
        `}
      >
        <Heading>
          Hey,{" "}
          <span
            css={`
              text-transform: capitalize;
            `}
          >
            {name ? name.split(" ")[0] : "User"}!
          </span>
        </Heading>
        <Heading
          css={`
            ${mq.sm} {
              margin-bottom: 2em;
            }
          `}
        >
          Here's your Term Insurance Recommendation.
        </Heading>
        <SubHeading>Tailored as per your needs!</SubHeading>
      </div>
      <MainText
        dangerouslySetInnerHTML={{
          __html:
            data?.result_text &&
            data.result_text
              ?.split("\n")
              .map(
                sentence =>
                  `<div>${sentence
                    .replace(
                      "%sum_assured%",
                      `<span style="color: ${colors.primary}">
            Rp ${parseInt(data["Total sum assured"]).toLocaleString("en-In")}
          </span>`,
                    )
                    .replace(
                      "%policy_term%",
                      `<span style="color: ${colors.primary}">
              ${data["Policy term"]}
            </span>`,
                    )}</div>`,
              )
              .join(""),
        }}
      ></MainText>
      <div
        css={`
          margin-top: 0.6em;
        `}
      >
        {/* <Info>
            The estimated rate of this coverage is between ₹6123.8 and ₹7106 per
            month.
          </Info> */}
        <Info>
          <form onSubmit={handleSubmit(handleQuotesClick)} autoComplete="off">
            I already have a Sum Assured of Rp{" "}
            <div
              css={`
                position: relative;
                display: inline;
              `}
            >
              <SumAssuredInput
                amount
                maxLength={30}
                {...register("manualSumAssured")}
              />
              <p
                css={`
                  position: absolute;
                  top: 100%;
                  left: 50%;
                  transform: translateX(-50%);
                  width: max-content;
                  color: red;
                  margin-top: 1em;
                  font-size: 0.79em;
                `}
              >
                {" "}
                {errors.manualSumAssured && errors.manualSumAssured.message}
              </p>{" "}
            </div>{" "}
            in mind, take me to{" "}
            <button
              type="submit"
              css={`
                &,
                &:hover {
                  color: ${colors.primary};
                }
                text-decoration: none;
                border: none;
                background: transparent;
              `}
            >
              quotes
            </button>
            .
          </form>
        </Info>
        <FewMoreQuestionsModal
          fewMoreQuestionsModal={fewMoreQuestionsModalShow}
          handleClose={() => setFewMoreQuestionsModalShow(false)}
          sumAssured={manualSumAssured}
          policyTerm={data["Policy term"]}
        />
      </div>
      <div
        css={`
          display: flex;
          gap: 1.6em;
          ${mq.sm} {
            justify-content: center;
          }
        `}
      >
        <Tooltip tooltipContent="Share your recommendation">
          <Link
            to="#"
            css={`
              ${CircleCTA}
            `}
          >
            <FaShareAlt />
          </Link>
        </Tooltip>
        <Tooltip tooltipContent="Start over">
          <a
            href="/"
            css={`
              ${CircleCTA}
            `}
          >
            <FaSyncAlt />
          </a>
        </Tooltip>
      </div>
    </div>
  );
}

export { ResultLeft };

const Heading = styled.p`
  font-size: 1.37em;
  color: ${colors.font1};

  ${mq.sm} {
    /* display: none; */
    text-align: center;
  }
`;

const SubHeading = styled.p`
  font-size: 0.9em;
  font-family: ${fonts.three};

  ${mq.sm} {
    text-align: center;
    font-size: 1.2em;
    margin-top: -1.6em;
    font-weight: 600;
  }
`;

const MainText = styled.strong`
  font-size: 1.87em;
  line-height: 1.6;
  margin-bottom: 0.6em;
  font-family: ${fonts.three};

  ${mq.sm} {
    font-size: 1.6em;
    line-height: 1.29;
    text-align: center;
  }
`;

const Info = styled.p`
  font-weight: 700;
  font-size: 0.97em;
  font-family: ${fonts.three};
  color: #404040;

  ${mq.sm} {
    text-align: center;
  }
`;

const SumAssuredInput = styled(NumberField)`
  border: none;
  border-bottom: 1px solid #ced4da;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  color: ${colors.primary};
  background-color: transparent;
  width: 10em;
  font-size: 1rem;
`;

const CircleCTA = css`
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.93em;
  width: 2.93em;
  background-color: ${colors.one};
  border: none;
  font-size: 1.1em;
  &,
  &:hover {
    color: #ffffff;
  }
  text-decoration: none;
`;
